import { call, put, SagaIterator, takeEvery } from './core/sagaEffects';
import { ResetStore, UpdatePushNotificationChannelSubscriptions } from 'acscp/actions';
import { setAppBadgeNumber } from 'acscp/mobile/device/setAppBadgeNumber';

export function* resetStoreSaga(): SagaIterator {
    yield takeEvery(ResetStore, resetStore);
}

function* resetStore(): SagaIterator {
    yield put(new UpdatePushNotificationChannelSubscriptions());

    yield call(setAppBadgeNumber, 0);
}
